module.exports = __webpack_public_path__ + "static/media/district7.d8e2cdca.png";